import ParamService from '../services/param.service'

export const paramModule = {
  namespaced: true,

  state: {
    paramResponse: []
  },

  actions: {
    control ({ commit }, fileToControl) {
      return ParamService.control(fileToControl).then(
        response => {
          const result = response.data
          commit('controlSuccess', result)
          return Promise.resolve(result)
        },
        error => {
          commit('controlFailure')
          return Promise.reject(error)
        }
      )
    },
    async reset ({ commit }) {
      commit('listReset')
    }
  },

  mutations: {
    controlSuccess (state, paramResponse) {
      state.paramResponse = paramResponse
    },
    controlFailure (state) {
      state.paramResponse = []
    },
    listReset (state) {
      state.paramResponse = []
    }
  }
}
